// If exam is Nail Technician Theory (Vietnamese) or Cosmetology Theory (Spanish), we don't show AiLA
export const EXCLUDED_EXAM_IDS = [
	"01cdb75a-3d93-430c-8577-337a660a836d",
	"7d571721-03b4-453e-b3d6-90fad964083c",
];
